import { Typography } from '@mui/material'
import dayjs from 'dayjs'
import Decimal from 'decimal.js'
import React from 'react'
import { conversionArray } from './config'

export const executeResponseError = (
	e,
	fallbackErrorMsg
) => {
	// eslint-disable-next-line
	console.log(e, fallbackErrorMsg)
	if(e?.response) {
		let error = e?.response?.data
		if (error?.error_message && error?.error_title) {
			return error?.error_title + ' ' + error?.error_message
		} else if (error?.error_title || error?.error_message) {
			return error?.error_title || error?.error_message
		} else if (error?.error_description) {
			return error?.error_description
		} else {
			return error
		}
	} else if ('message' in e) {
		return e.message
	}
	return fallbackErrorMsg
}


export const capitalizeFirstLetter = (val, isTab) => {
	if(val && isTab) {
		if(val === 'usd') return 'Crypto USDT'
		if(val === 'crypto_eur') return 'Crypto EURT'
	}
	if (!val) return ''

	const lowerCase = val.toLowerCase()

	return lowerCase.charAt(0).toUpperCase() + lowerCase.slice(1)
}

export const getParameterByName = (name) => {
	//eslint-disable-next-line
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
	let regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
		results = regex.exec(location.search)
	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
}

export const getAssetNumber = (num, motion, defaultColor, red, green, action, isRight) => {
	return <Typography className='assets-number'
		sx={{color: motion ? green : (motion === undefined ? defaultColor : red)}}
	>
		{action ? (isRight ? num + ' ' + action  : action + ' ' + num) : num}
	</Typography>
}

export const getNames = (title) => {
	title = title.replace(/\u00A0/, '').trim()
	if (title?.includes('/')) return title?.replace(/ /g,'_').replace('.','_').split('/')
	if (title?.includes(' ')) return title?.replace(/ /g,'_').toLowerCase()
	if (title?.includes('.')) return title?.replace('.','_').toLowerCase()
	if (title?.includes('\'')) return title?.replace('\'','_').toLowerCase()
	if (title?.includes('&')) return title?.replace('&','_').toLowerCase()
	if (title?.includes('-')) return title?.replace('-','_').toLowerCase()
	return title.toLowerCase()
}

export const getSoIdNumber = (asset) => asset.replace('asset_', '')

export const getGetSide = (currencySides, keyOrValues) => {
	let result
	let key
	for (key in currencySides) {
		let side = currencySides[key].findIndex(i => i === keyOrValues)
		if (side !== -1) result = key
	}
	return result
}

export const getTargetAssetName = (assetName, assetType) => {
	let targetAssetName = null
	assetType=assetType.toLowerCase()
	switch(assetType) {
	case 'currencies':
		targetAssetName =  (assetName).substring(0, 3) // something like USD| EUR| BTC
		break
	case 'crypto_eur':
		targetAssetName = 'EUR'
		break
	case 'usd':
	case 'nft':
		targetAssetName = 'USD'
		break
	case 'commodities':
		targetAssetName = 'USD'
		break
	case 'stocks':
		targetAssetName =  (assetName).substr(assetName.length - 3) //something like USD| EUR| BTC
		targetAssetName = targetAssetName === 'EUR' ? targetAssetName : 'USD'
		break
	case 'indices':
		targetAssetName =  (assetName).substr(assetName.length - 3) //something like USD| EUR| BTC
		if ( conversionArray.indexOf(targetAssetName) === -1) {
			targetAssetName = 'USD' // not in the conversion currency
		}
		break
	case 'pairs':
		targetAssetName = 'USD'
		break
	case 'bitcoin':
		targetAssetName = 'BTC'
		break
	case 'ethereum':
		targetAssetName = 'ETH'
		break
	case 'monero':
		break
		// eslint-disable-next-line no-console
	default: console.error('warning type')
		break
	}
	return targetAssetName
}

export const addCommas = (nStr) => {
	nStr += ''
	let x = nStr.split('.')
	let x1 = x[0]
	let x2 = x.length > 1 ? '.' + x[1] : ''
	let rgx = /(\d+)(\d{3})/
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, '$1' + ',' + '$2')
	}
	return x1 + x2
}

function toFixedFormat(x) {
	if (Math.abs(x) < 1.0) {
		let e = parseInt(x.toString().split('e-')[1]);
		if (e) {
			x *= Math.pow(10,e-1);
			x = '0.' + (new Array(e)).join('0') + (+x.toFixed(2)).toString().substring(2);
		}
	} else {
		let e = parseInt(x.toString().split('+')[1]);
		if (e > 20) {
			e -= 20;
			x /= Math.pow(10,e);
			x += (new Array(e+1)).join('0');
		}
	}
	return x;
}

export const toFixedIfNull = (amount, numberTemp) => {
	let number = numberTemp
	if (isNaN(amount)) { return amount; }
	if (amount==null) { return amount; }
	if (typeof amount==='undefined') { return amount; }
	if (number == null || typeof number==='undefined' ) { return amount; }
	if (!+parseFloat(amount).toFixed(number)) {
		/*eslint no-constant-condition: ["error", { "checkLoops": false }]*/
		while (true) {
			number = number + 1
			if (+parseFloat(amount).toFixed(number) > 0) {
				break
			}
			if (number > 15) {
				number = number + 5
				break
			}
		}
	}
	if (typeof Decimal==='undefined')
	{
		return toFixedFormat(+parseFloat(amount).toFixed(number));
	}
	else
	{
		var _r = new Decimal((new Decimal(amount)).toFixed(number));
		if (numberTemp === 6) {
			// console.log(number, _r.toFixed(number))
			//eslint-disable-next-line
			console.log(toFixedFormat(+_r.toFixed(number)))
		}
		//eslint-disable-next-line
		return (_r.comparedTo(0)==0 ? toFixedFormat(+(new Decimal(0)).toFixed(number)) : toFixedFormat(+_r.toFixed(number)));
	}
}

export const decimalPlaces = (number) => {
	//eslint-disable-next-line
	if (number.toString().split(/[\.e]/).length === 1) return 0
	let result
	//eslint-disable-next-line
	number.toString().replace(/[\.e]/, reg => {
		switch (reg) {
		case '.': {
			result = number.toString().split('.')[1].length
			return
		}
		case 'e': {
			result = Math.abs(number.toString().split('e')[1])
			return
		}}})
	return result
}
export const getLangLink = (link, lang) => {
	if (!lang || lang === 'en') return link
	return '/' + lang + link
}
export const getSimpleLang = (lang) => lang.split('-')[0]

export const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export const getNearestStart = (activeHours) => {
	let result
	let currentTimeObj = new Date()
	let currentTime = Math.round(currentTimeObj.getTime() / 1000)
	let nearestStart = null
	if (activeHours) {
		for (let i = activeHours.length - 1; i >= 0; i--) {
			if ((activeHours[i]['startTime'] - 30) < currentTime && (activeHours[i]['endTime'] + 30) > currentTime) {
				break
			} else {
				nearestStart = activeHours[i]['startTime']
			}
		}
	}
	if (nearestStart > 0) {
		let dt = new Date(nearestStart * 1000);
		let hours = dt.getUTCHours();
		let minutes = '0' + dt.getUTCMinutes();
		let seconds = '0' + dt.getUTCSeconds();
		//debugger;
		let formattedTime;
		if (dt.getUTCDate() == currentTimeObj.getUTCDate() && dt.getUTCMonth() == currentTimeObj.getUTCMonth()) {
			formattedTime = hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
		} else {
			// eslint-disable-next-line
			formattedTime = dt.getUTCDate() + ' ' + months[dt.getUTCMonth()] + ' ' + hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
		}
		result =  ' ' + formattedTime + ' GMT'
	}
	return result
}

export const getNewsArray = (data) => {
	const parser = new DOMParser()
	const xmlDoc = parser.parseFromString(data,'text/xml')
	const rss = xmlDoc.querySelectorAll('item')
	let arr = []
	rss.forEach(item => {
		let obj = {}
		obj.title = item.querySelector('title').innerHTML
		obj.text = item.querySelector('description').innerHTML
		obj.date = dayjs(item.querySelector('pubDate').innerHTML).format('DD.MM.YYYY')
		arr.push(obj)
	})
	return arr
}


export const forexMath = (function () {
	return {
		formatRateForTrade : function(rate, trade) {
			return ((trade?.type === 'crypto') ? new Decimal(rate).toFixed(trade?.tailDigits).toString() :
				toFixedIfNull(rate, trade?.tailDigits))
		},
		formatSwapForTrade : function(swap, trade) {
			if(swap === 0 || swap === null){
				return '0'
			}
			return ((trade.currency === 'BTC' || trade?.currency === 'ETH') ?
				new Decimal(swap).toFixed(8).toString() :
				new Decimal(swap).toFixed(2).toString())
		},
		getMultClient: function (entity) {
			// eslint-disable-next-line
			return (parseFloat(((new Decimal(entity.lotSize)).mul(forexMath.getSinglePip(entity.pipDecimalPlaces))).toString()))
		},
		getPipsDiffer: function (thisPrice, entryRate) {
			return this.lazyDecimal(thisPrice).minus(new Decimal(entryRate));
		},
		getSinglePip: function (numAfterDecimal) {
			return (new Decimal(1)).dividedBy(Math.pow(10,numAfterDecimal));
		},
		getTradePnl: function (
			pipsDiffer,
			thisSinglePip,
			tradePipValue,
			lev,
			thisMult,
			stopLossAmount,
			takeProfitAmount,
			marginTrade
		) {
			if (lev === undefined) lev = 1
			if (thisMult === undefined) thisMult = 1
			let tradePnl = (this.lazyDecimal(pipsDiffer).times(tradePipValue).dividedBy(thisSinglePip))
			if (marginTrade !== true && !(stopLossAmount === undefined)) {
				let stopLossAmountDec = new Decimal(stopLossAmount)
				// Normalize PNL
				if (tradePnl.comparedTo(stopLossAmountDec.times(-1)) === -1
					&& stopLossAmountDec.comparedTo(0) === 1) {
					tradePnl = (new Decimal(stopLossAmount)).times(-1)
				}
			}
			if (marginTrade !== true && !(takeProfitAmount === undefined)) {
				let takeProfitAmountDec = new Decimal(takeProfitAmount)
				if (tradePnl.comparedTo((new Decimal(takeProfitAmount))) === 1
					&& takeProfitAmountDec.comparedTo(0)===1) {
					tradePnl = (new Decimal(takeProfitAmount))
				}
			}
			return tradePnl;
		},
		getTradePnlStr: function (tradePnl, digitNum) {
			try{
				return toFixedIfNull(tradePnl,digitNum);
			} catch(err){
				// eslint-disable-next-line
				console.log(err)
			}
		},
		//Converts string to decimal if it is not a decimal, otherwise returns the decimal
		getTradeSizeValueStr: function (lotSize, lev) {
			if (typeof lotSize == 'undefined' || typeof lev == 'undefined')	return '-'
			return (this.lazyDecimal(lotSize)).mul(parseFloat(lev)).toString()
		},
		lazyDecimal: function(strOrDecimal) {
			if (typeof strOrDecimal.mul == 'undefined') { //This is a string
				return new Decimal(strOrDecimal)
			}
			else
			{
				return strOrDecimal
			}
		}
	}
})()
export const getIsMonday = () => {
	return dayjs().get('d') === 0
}

export const zeroOnUndefined = (amount) => {
	let x = Number.parseFloat(amount)
	if (isNaN(x)) { return 0 }
	if (x==null) { return 0 }
	if (x===undefined) { return 0 }
	if (typeof x=='undefined') { return 0 }
	amount=amount.toString().replace(/^0+/, '')
	if (Number.parseFloat(amount)!=amount) { return 0 }
	return amount
}


export const handleCancelOpen = async (dispatch, action, alert, t) => {
	try {
		alert.info(t('Canceling an open trade'), {loader: true, timeout: 0, title: t('Canceling trade') })
		const res = await dispatch(action)
		if (res) {
			alert.removeAll()
			alert.success(t('The trade is closed'))
		}
	} catch (e) {
		alert.removeAll()
		alert.error(e.message)
	}
}

export const handleCancelPending = async (dispatch, action, alert, t) => {
	try {
		alert.info(t('Canceling a pending trade'), {loader: true, timeout: 0, title: t('Canceling trade')})
		const res = await dispatch(action)
		if (res) {
			alert.removeAll()
			alert.success(t('The pending trade has been cancelled'))
		}
	} catch (e) {
		alert.removeAll()
		'message' in e && alert.error(e.message)
	}
}

export function updateSlTp(
	executionEntryRate,
	pipValue,
	pipDecimalPlaces,
	position,
	type,
	value,
	tailDigitOfCurrency,
	setStopLossAmount,
	setTakeProfitAmount,
	tailDigits){

	let chosenPrice = parseFloat(zeroOnUndefined(executionEntryRate))
	let executePriceTrade = new Decimal(Number(chosenPrice))
	let chooseUpdateTradePipValue = new Decimal(Number(pipValue))
	let singlePip =  new Decimal(1).mul(1/Math.pow(10, pipDecimalPlaces))
	let pipsNum = (new Decimal(value ? value : 0))
	if(type === 'sl') {
		let slAmount
		if (position === 'buy') {
			slAmount = new Decimal(pipsNum - executePriceTrade)
				.dividedBy(singlePip).times(chooseUpdateTradePipValue)
		} else {
			slAmount = new Decimal(executePriceTrade - pipsNum)
				.dividedBy(singlePip).times(chooseUpdateTradePipValue)
		}
		slAmount = zeroOnUndefined(toFixedIfNull(slAmount, tailDigitOfCurrency))
		if(slAmount === '0' || !value) {
			setStopLossAmount('')
		} else {
			setStopLossAmount(parseFloat(parseFloat(slAmount).toFixed(tailDigits)))
		}
	}
	if(type === 'tp' ) {
		let tpAmount
		if(position === 'buy'){
			tpAmount = new Decimal(pipsNum - executePriceTrade)
				.dividedBy(singlePip).times(chooseUpdateTradePipValue)
		} else {
			tpAmount = new Decimal(executePriceTrade - pipsNum)
				.dividedBy(singlePip).times(chooseUpdateTradePipValue)
		}
		tpAmount  = zeroOnUndefined(toFixedIfNull(tpAmount, tailDigitOfCurrency))
		if(tpAmount === '0' || !value) {
			setTakeProfitAmount('')
		} else {
			setTakeProfitAmount(parseFloat(parseFloat(tpAmount).toFixed(tailDigits)))
		}
	}
}

export function updateSlTpOpenTrade(
	price,
	executionEntryRate,
	pipValueServer,
	pipDecimalPlaces,
	type,
	position,
	tailDigitOfCurrency,
	setStopLossAmount,
	setTakeProfitAmount
) {

	let priceVal = parseFloat(price)
	let executePriceTrade = new Decimal(Number(executionEntryRate))
	let chooseUpdateTradePipValue = new Decimal(Number(pipValueServer))
	let singlePip =  new Decimal(1).mul(1/Math.pow(10, pipDecimalPlaces))
	if(type === 'sl') {
		let slDecimal = (new Decimal(priceVal))
		let slAmount
		if (position === 'buy'){
			slAmount = new Decimal(slDecimal - executePriceTrade)
				.dividedBy(singlePip).times(chooseUpdateTradePipValue)
		} else {
			slAmount = new Decimal(executePriceTrade - slDecimal)
				.dividedBy(singlePip).times(chooseUpdateTradePipValue)
		}
		slAmount  = zeroOnUndefined(toFixedIfNull(slAmount, tailDigitOfCurrency))
		if(slAmount === 0 || !price){
			setStopLossAmount('')
		} else {
			setStopLossAmount(parseFloat(parseFloat(slAmount).toFixed(5)))
		}
	}
	if(type === 'tp' ) {
		let tpDecimal = (new Decimal(priceVal)); // Take profit price
		let tpAmount;
		if(position === 'buy'){
			tpAmount = new Decimal(tpDecimal - executePriceTrade)
				.dividedBy(singlePip).times(chooseUpdateTradePipValue)
		}else{
			tpAmount =  new Decimal(executePriceTrade-tpDecimal)
				.dividedBy(singlePip).times(chooseUpdateTradePipValue)
		}
		tpAmount  = zeroOnUndefined(toFixedIfNull(tpAmount, tailDigitOfCurrency))
		if (tpAmount === 0 || !price) {
			setTakeProfitAmount('')
		} else {
			setTakeProfitAmount(parseFloat(parseFloat(tpAmount).toFixed(5)))
		}
	}
}

export const getMediaUrl = (asset) => {
	if (asset) {
		return process.env.REACT_APP_URL ? process.env.REACT_APP_URL
			+ process.env.REACT_APP_URL_MEDIA + 'icons/'
			: window.TRADING_APP_URL + window.TRADING_APP_URL_MEDIA + 'icons/';
	}
	return process.env.REACT_APP_URL ? process.env.REACT_APP_URL
		+ process.env.REACT_APP_URL_MEDIA
		: window.TRADING_APP_URL + window.TRADING_APP_URL_MEDIA;
}
